import styled from '@emotion/styled';
import { breakpoints } from '~/theme';
import { Link } from '../Link';

export const RemoveAddedPageHeight = styled.div((props) => ({
    marginBottom: '-150vh',
    pointerEvents: 'none',
}));

export const Wrapper = styled.div(({ theme }) => ({
    position: 'sticky',
    bottom: theme.space[5],
    display: 'inline',
    width: 'fit-content',
    float: 'right',
    pointerEvents: 'none',

    '&:before': {
        content: '""',
        display: 'block',
        height: '150vh',
    },
}));

export const ScrollToTopContainer = styled.div(({ theme }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    pointerEvents: 'all',
    gap: theme.space[2],
    whiteSpace: 'nowrap',
    justifyContent: 'end',
    marginRight: theme.space[3],
    width: 'fit-content',

    [breakpoints.md]: { marginRight: theme.space[6] },
}));

export const ScrollLink = styled(Link)(() => ({
    background: 'transparent',
    border: 0,
}));

export const ScrollToTopText = styled.span(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.space[2],
    whiteSpace: 'nowrap',
    width: 'fit-content',
    fontSize: theme.fontSizes.frog,
    lineHeight: theme.lineHeights.rat,
    color: theme.colors.black,

    svg: {
        '--size': `calc(${theme.space[4]} + ${theme.space[1]})`,

        backgroundColor: theme.colors.brandBlue,
        color: theme.colors.white,
        width: 'var(--size)',
        height: 'var(--size)',
        borderRadius: 'var(--size)',
        padding: 2,
    },
}));
